import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { api, mediaUrl, money } from "../../api/client";

export default function OwnerDashboard() {
  const [venue, setVenue] = useState(null);
  const [reservations, setReservations] = useState([]);

  useEffect(() => {
    api("/api/owner/venue").then(setVenue).catch(() => setVenue(null));
    api("/api/owner/reservations").then(setReservations).catch(() => setReservations([]));
  }, []);

  const pending = reservations.filter((row) => row.status === "pending").length;

  return (
    <DashboardLayout title="Your house tonight">
      <div className="grid gap-4 sm:grid-cols-3">
        <Stat color="bg-blush" label="Public page" value={venue?.published ? "Live" : "Draft"} />
        <Stat color="bg-lilac" label="Reservations" value={reservations.length} />
        <Stat color="bg-gold-soft" label="Waiting" value={pending} />
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <section className="card overflow-hidden">
          {venue?.coverImage && (
            <img
              src={mediaUrl(venue.coverImage)}
              alt=""
              className="h-48 w-full object-cover"
            />
          )}
          <div className="p-6">
            <p className="text-xs uppercase tracking-[0.2em] text-rose">Your page</p>
            <h2 className="font-serif text-3xl">{venue?.name || "Untitled venue"}</h2>
            <p className="mt-2 text-sm text-ink/60">{venue?.tagline}</p>
            <div className="mt-5 flex flex-wrap gap-3">
              <Link to="/owner/venue" className="btn-ink">
                Edit details
              </Link>
              {venue?.slug && (
                <Link to={`/u/${venue.slug}`} className="btn-ghost">
                  Open public page
                </Link>
              )}
            </div>
          </div>
        </section>
        <section className="card p-6">
          <h3 className="font-serif text-2xl">Latest requests</h3>
          <div className="mt-4 space-y-3">
            {reservations.slice(0, 4).map((row) => (
              <div key={row.id} className="rounded-2xl bg-cream px-4 py-3">
                <p className="font-medium">{row.guestName}</p>
                <p className="text-sm text-ink/55">
                  {row.itemName} · {money(row.total)} · {row.status}
                </p>
              </div>
            ))}
            {!reservations.length && (
              <p className="text-sm text-ink/50">No reservations yet.</p>
            )}
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
}

function Stat({ color, label, value }) {
  return (
    <div className={`rounded-[1.6rem] ${color} p-5`}>
      <p className="text-xs uppercase tracking-[0.18em] text-ink/50">{label}</p>
      <p className="mt-2 font-serif text-3xl">{value}</p>
    </div>
  );
}
